/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import { LangList } from '@/enums';
import Cookies from 'js-cookie';
import { getUrlKey } from './location';

class Language {
    lang = 'en';

    constructor() {
        this.lang = this.getLang();

        Cookies.set('language', this.lang, {
            secure: true,
            SameSite: 'None',
        });
    }

    getLang() {
        const lang = getUrlKey('lang') || Cookies.get('language') || navigator.language;
        return this.format(lang);
    }

    /**
     * @description 将 lang 统一成目前 LanguageList 支持的语言
     * @see {@link https://developer.mozilla.org/zh-CN/docs/Web/API/Navigator/language} navigator.language 浏览器界面语言（BCP 47 规范）
     * @see {@lilnk https://stackoverflow.com/questions/5580876/navigator-language-list-of-all-languages/36042028#36042028} navigator.language 列表
     * @param {string} lang
     */
    format(lang) {
        lang = lang.toLowerCase();

        if (['zh-hk', 'zh-mo', 'zh-tw'].includes(lang) || /zh-hant/.test(lang)) {
            // 繁体中文
            lang = 'zh-tw';
        } else if (['zh', 'zh-sg', 'zh-cn'].includes(lang) || /zh-hans/.test(lang)) {
            // 简体中文
            lang = 'zh-cn';
        } else if (/^(\w+)-/.test(lang)) {
            // 其他语言移除后缀
            lang = lang.replace(/^([^-]+)-.+$/, '$1');
        }

        return LangList.includes(lang) ? lang : 'en';
    }
}

export default Language;
